import React from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';
import TreatmentMultichoixSearch from '@client/feature/treatment/TreatmentMultichoixSearch';

const root = document.getElementById('treatmentMultichoixSearch');

/**
 * This app is responsible for the treatment multichoix search
 *
 * @returns {Element}
 * @constructor
 */
const TreatmentMultichoixSearchApp = () => {
  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <TreatmentMultichoixSearch />
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 */
ReactDOM.createRoot(root).render(<TreatmentMultichoixSearchApp />);
